import Dashboard from 'components/global/Dashboard/Dashboard';

export default Dashboard;
